// object-fit IE fix
//objectFitImages();

function Utils() {

}


Utils.prototype = {
    constructor: Utils,
    isElementInView: function (element, fullyInView) {
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }
};

var Utils = new Utils();


// load files programatically function
const load = (function () {
    function _load(tag) {
      return function (url) {
        return new Promise((resolve, reject) => {
          const element = document.createElement(tag);
          let parent = 'body';
          let attr = 'src';
  
          element.onload = () => resolve(url);
          element.onerror = () => reject(element.error);
  
          switch (tag) {
            case 'script':
              element.async = true;
              break;
            case 'link':
              element.type = 'text/css';
              element.rel = 'stylesheet';
              attr = 'href';
              parent = 'head';
          }
  
          element[attr] = url;
          document[parent].appendChild(element);
        });
      };
    }
  
    return {
      css: _load('link'),
      js: _load('script'),
      img: _load('img')
    };
  })();

function adaptBanner() {
    if($(window).width() > 860) {
        $('.banner__main-title').removeClass('adapt__parent');
    } else {
        if(!$('.banner__main-title').hasClass('adapt__parent')){
            $('.banner__main-title').addClass('adapt__parent');
         }
    }
}

function showImages() {
    $('.adapt__hide').removeClass('adapt__hide');

}


// Image adaptation
function adaptImageOnBackground() { 
    $('.adapt__parent').each(function (index, item) {
        $(item).find('.adapt__target').each(function (imageIndex, imageItem) {
            
            $(imageItem).removeClass('increase-height');
            if ($(imageItem).height() < $(item).outerHeight()) {
                $(imageItem).addClass('increase-height');
            }
        });
    });
    showImages();
}

function init() {
    adaptBanner();
    var imgDefer = document.getElementsByTagName('img');
    for (var i = 0; i < imgDefer.length; i++) {
        if (imgDefer[i].getAttribute('data-src')) {
            imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('data-src'));
            if( imgDefer[i].classList.contains('adapt__target')) {
                // imgDefer[i].classList.add('adapt__hide');
            }
        }
    }
    setTimeout(function () {
        adaptImageOnBackground();
    }, 500);

    
}


function initNewsSlider() {
    // init owl carousel
    const prev = $('.text-slider .prev');
    const next = $('.text-slider .next');
    const owl = $('.home-news__texts').owlCarousel({
      loop: false,
      nav: true,
      navText : ["",""],
      items: 1,
      autoHeight: true,
      autoplay: true,
      autoplaySpeed: 800
    });
    
    prev.on('click', () => {
      owl
        .trigger('prev.owl.carousel', [800])
        .trigger('stop.owl.autoplay');
    });
    next.on('click', () => {
      owl
        .trigger('next.owl.carousel', [800])
        .trigger('stop.owl.autoplay');
    });
    prev.addClass('hide');
    
  
    // new instance of ImageCards
    
    const slider = new ImageCards('.home-news__cards');
  
    
    owl.on('changed.owl.carousel', (e) => {
        slider.change(e.page.index);

        if (e.page.index === 0) {
            prev.addClass('hide');
            next.removeClass('hide');
        }
        else if (e.page.index === e.page.count - 1) {
            prev.removeClass('hide');
            next.addClass('hide');
        }
        else {
            prev.removeClass('hide');
            next.removeClass('hide');
        }
    });
    
    
  }


  function round(value, decimals) {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
  }

  function animateValue(obj, end, duration) {
    var start = 0;
    var range = end - start;
    var current = start;
    var increment = end > start? 1 : -1;
    var stepTime = Math.abs(Math.floor(duration / range));

    if(end < 10) {
        increment = parseFloat(0.1);
        stepTime = Math.floor(stepTime / 10);
    }
    var timer = setInterval(function() {
        current = parseFloat(current) + parseFloat(increment);    
       // current = round(current, 1);
        
        if(end < 10) {
            current = current.toFixed(1);
        }
        
        
        obj.html(current);
        if (current == end) {
            clearInterval(timer);
        }
    }, stepTime);
}

function checkIfStartCoutn(element) {
    animateValue(element, element.attr('data-to'), 2500);
}

function addAnimation(el) {
    el.addClass('animate');  
}

function checkAnimations() {
    var time = 500;
    i = 1;

    $('.animated').each(function(element){
        if(Utils.isElementInView($(this), false)) {
            var el = $(this);
            if($(this).hasClass('delay')) {   
                addAnimation(el);
               

            } else {
                addAnimation(el);
            }

            i++;
        }
    });
}

function adaptContainerHeight() {

    var i = 1;

    if($(window).width() >= 900) {
        i = 1.5;
    }

    $('.flipbook__container').each(function(e){
        $(this).css('height', $(this).width() +'px');
    });
    
    $('.breakfast__img').each(function(e){
        $(this).css('height', $(this).width() * i +'px');
    })
}

/**
 * Fixes a bug (possibly a rounding error?) in Google Maps API v3 whereby scrollbars appear
 * on InfoWindow content.
 * 
 * Yes, this is incredibly hacky and ugly. Argh.
 * 
 * Requires jQuery
 * 
 * Should be called like this...
 * google.maps.event.addListener(infoWindow, 'domready', fixInfoWindowScrollbars);
 * (after creating the infoWindow object, but before calling open())
 */
function fixInfoWindowScrollbars() {

if (this.hasFixApplied) return;

// Find the DOM node for this infoWindow
var InfoWindowWrapper = $((this.B || this.D).contentNode.parentElement);

// We disable scrollbars temporarily
// Then increase .infoWindow's natural dimensions by 2px in width and height    

InfoWindowWrapper.children().css('overflow', 'visible');

var InfoWindowElement = InfoWindowWrapper.find('.infoWindow');
InfoWindowElement            
    .width(function(i, oldWidth) { return oldWidth + 3 })

// Will this content need scrollbars?  If so, add another 20px padding on right
if (InfoWindowElement.height() > InfoWindowWrapper.height()) {
    InfoWindowElement
        .css({'padding-right': '20px'})
        .width(function(i, oldWidth) { return oldWidth - 20 })
}
    
InfoWindowElement
    .height(function(i, oldHeight) { return oldHeight + 3 })            

// Replace infoWindow content with our new DOM nodes
this.hasFixApplied = true;
this.setContent(InfoWindowElement.get(0))

}

window.onload = init;

function InitForm(){
   
    $( "#slider" ).slider({
        min: 0,
        max: 2000,
        range: "min",
        value: $("#slider-input input").val() > 0 ? $( "#slider-input input").val() : 150,
        slide: function( event, ui ) {
            if($("#slider-value span").length > 0) {
                $("#slider-value span").html(ui.value);
            } else {
                $("#slider-value").html(ui.value);
            }
            $( "#slider-input input").val(ui.value);
        },
        create: function(event, ui){
            $( "#slider-value span").html($("#slider-input input").val() > 0 ? $( "#slider-input input").val() : 150)
        } 
    }); 

    var dateToday = new Date();
    $( ".order-form__item--date input" ).datepicker({
        changeMonth: true,
        changeYear: true,
        minDate: dateToday,

    });
    $( ".order-form__item--time input" ).timepicker({
        timeFormat: 'HH:mm',
        interval: 60,
        minTime: '00:00',
        maxTime: '23:00',        
        startTime: '01:00',
        dynamic: false,
        dropdown: true,
        scrollbar: true
        
    }).attr('readonly', 'true').
        keypress(function(event){
      if(event.keyCode == 8){
        event.preventDefault();
      }
    });


    var x, i, j, selElmnt, a, b, c;
    /* Look for any elements with the class "custom-select": */
    x = document.getElementsByClassName("custom-select");
    for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < selElmnt.length; j++) {
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function(e) {
                /* When an item is clicked, update the original select box,
                and the selected item: */
                var y, i, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                h = this.parentNode.previousSibling;
                for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    for (k = 0; k < y.length; k++) {
                    y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
                }
                h.click();
            });
            b.appendChild(c);
        }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
        /* When the select box is clicked, close any other select boxes,
        and open/close the current select box: */
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
        });
    }

    function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var x, y, i, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    for (i = 0; i < y.length; i++) {
        if (elmnt == y[i]) {
        arrNo.push(i)
        } else {
        y[i].classList.remove("select-arrow-active");
        }
    }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
            }
        }
    }

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener("click", closeAllSelect); 
}    

function initMap() {
    if(typeof markers !== 'undefined') {
        if($('#footer-map').length > 0) {
            $(function () {
                
                var map;
                var infowindow = new google.maps.InfoWindow();
                var bounds = new google.maps.LatLngBounds();

                var locations = Array();

                
                markers.forEach(element => {
                    locations.push(element);
                });

                myOptions = {
                    center: {lat: 49.197017, lng: 16.59447},
                    zoom: 4,
                    //disableDefaultUI: true,
                    mapTypeId: 'roadmap'

                }
                

                map = new google.maps.Map($("#footer-map").get(0), myOptions);

                function placeMarker( loc, i ) {
                  
                    var markerIcon = '../FaT/img/png/pin_offices.png?maxsidesize=25';
                    if(loc.Drop == 2) {
                        markerIcon = '../FaT/img/png/pin_school.png?maxsidesize=25';  
                    }
                    


                    var latLng = new google.maps.LatLng( loc.Long, loc.Lat);
                    var marker = new google.maps.Marker({
                      position : latLng,
                      map      : map,
                      icon     : markerIcon
                    });
                    
                    bounds.extend( latLng );
                        if($('.where__table--row').length > 0) {
                            google.maps.event.addDomListener($('.where__table--row')[i],'click',function(){
                                google.maps.event.trigger(marker,'click',{});
                            });
                        }
                        
                    google.maps.event.addListener(marker, 'click', function(){
                        infowindow.close(); // Close previously opened infowindow
                        infowindow.setContent( "<div id='infowindow' class='info'><div class='info__left'>\
                                                    <div class='info__wrap'>\
                                                        <h2 class='yellow'>" + loc.Name +"</h2>\
                                                        <div class='info__adress'><address>" + loc.Text +" <br />" + loc.PostalCode + ", " + loc.City + "</address></div>\
                                                        <div class='info__open'><h3>" + loc.TextOpen + "</h3><p>" + loc.Hours + "</p></div>\
                                                        <div class='info__person'><h3>" + loc.TextKontakt+ "</h3><div class='info__name'>" + loc.ContactName + "</div><div class='info__position'>" + loc.Position + "</div></div>\
                                                        <div class='info__contact'><a href='mailto:" + loc.Mail + "'>" + loc.Mail + "</a> <a href='tel:" + loc.Tel + "'>" + loc.Tel + "</a></div>\
                                                        <div class='info__button'><a href='" + loc.Url + "' class='btn'>" + loc.TextDetail + "</a></div></div>\
                                                    </div><div class='info__right' style='background: url(" + loc.Image + ");'></div></div>");
                                                    
                        infowindow.setOptions({height: 800,});
                        infowindow.open(map, marker);
                    });
                  }


                  for(var i=0; i<locations.length; i++) {
                    placeMarker( locations[i], i );
                  } 

                  map.fitBounds( bounds );
              });
        }
    }
}

$(document).ready(function() {
    $('.click-gallery .Pager').remove();

    $(".mobile-header .mobile-toggle").click(e => {
        $(e.currentTarget).toggleClass("active");
        $('.header .nav').toggleClass("open");
        $('body').toggleClass("mobileMenu");
    });


    // FOOTER
    $('.social').wrapAll('<div class="footer__social-wrap"></div>');
    $('.restaurant').wrapAll('<div class="footer__restaurants-wrap"></div>');

    if($('.home-news__texts').length > 0) {
        initNewsSlider();
    }


  

    $('.meal button').click(function(event) {
        event.preventDefault();
    });
    
    checkAnimations();
 
    $(window).on('scroll', function(){
        $('.js-numbers').each(function(element){
            if(!$(this).hasClass('start-count')) {
                var isElementInView = Utils.isElementInView($(this), true); 
                if (isElementInView) {
                    $(this).addClass('start-count');
                    checkIfStartCoutn($(this));
                }
            }
        });

        checkAnimations();

    });

    // List click
    $('.where__table--row').click(function(event) {
        event.preventDefault();
        if($(window).width() < 860) {
            window.location.href = $(this).attr('data-url');
        }
    })

    // List team
    var i = 1;
    $(".team__wrap .team__person").each(function() {
        var newClass = 'yellow';
        if((i < 4) || ((i > 8) && (i < 13))) {
            $(this).addClass(newClass);
        }
        i++;
    });

    if($('.banner__main--textwrap').length > 0) {
        if($('.banner__subtitle').length > 0) {
            $('.banner__main--textwrap').append("<div class='banner__subtitle banner__subtitle--desktop'>" + $('.banner__subtitle').html() + "</div>");
        }

        if($('.banner__buttons-wrap a').length > 0) {
            $('.banner__main--textwrap').append("<div class='banner__buttons-wrap banner__buttons-wrap--desktop'>" + $('.banner__buttons-wrap').html()) + "</div>";
        }
    }
    

    $('#myRange').change(function() {
        $('.budget').val($(this).val());
    });

    
    detailGallery = $('.click-gallery .owl-carousel').owlCarousel({
        loop: false,
        nav: false,
        items: 1,
        autoHeight: true,
        margin: 5,
        lazyLoad: true
    });
    $('.news-detail .prev').on('click', () => detailGallery.trigger('prev.owl.carousel'));
    $('.news-detail .next').on('click', () => detailGallery.trigger('next.owl.carousel'));

    $(".close-banner").click(function() {
        $(".actionBanner").hide(); // Hide the banner
    });
  
    var length = $(".click-gallery .owl-stage-outer").length;

    var carTimer = setInterval(function(){
        var gotheight = true;
        for(var i=0; i<length; i++){
            if($(".owl-stage-outer").eq(i).height() < 100){
                gotheight = false;
                break;
            }
        }

        if(gotheight)
            clearInterval(carTimer);
        else
        detailGallery.trigger('refresh.owl.carousel', [100]);         
    }, 300);
    

    $('a[href^="#"]').click(function(event){
        event.preventDefault();
        var offset = $($(this).attr('href')).offset();

        $('.navbar-toggler-main').removeClass('active');
        $('.header__menu-container').removeClass('expanded');
        $(".header__menu-container .arrow").each(function(){
            if(!$(this).hasClass('down')) {
                $(this).addClass('down');
            }
        });
        $('body').removeClass('no-scroll');


        
            $('html, body').animate({
                scrollTop: offset.top
            });
    });    

    // Flipbox
    $(".flipbook__container").click(function(){
        $(this).toggleClass('flip');
    })

    InitForm();

    $(document).on( "click", '.owl-nav button', function(event) {
       event.preventDefault();
    });


    

    $('.meal, .lunch').each(function(){
        if($(this).find('.meal__items').length == 1) {
            $(this).addClass('meal__noheader');
        }
    })


    // Menu
    $('.navbar-toggler-main').on('click', function () {
        var self = $(this);
        $(this).toggleClass('active');
        $('.header__menu-container').toggleClass('expanded');
        $(".header__menu-container ul ul").css("display", "none");
        $('body').toggleClass('no-scroll');


    });

    $('#menuElem > li').each(function(){
        if($(this).find('ul').length > 0) {
            $(this).addClass('has-child');
            $(this).find(' > a').after('<span class="mainnav__icon"><i class="arrow down"></i></span>');
        }
    });

    

    $('.mainnav__icon').click(function(){
        $(this).find('.arrow').toggleClass('down');
        $(this).parent().find('ul').slideToggle();
    });


    $(window).resize(function() {
        if($(window).width() > 960) {
          //  $('.header__menu-container').removeClass('expanded');
        }
    });


    $(".form-control.hasDatepicker").keypress(function(event) {event.preventDefault();});
    $(".form-control.hasDatepicker").prop('readonly', true);
    $(".order-form__item--time input").prop('readonly', true);

    $('body').on('touchmove', function (e) {
        if ($(this).hasClass('no-scroll')) {
            e.preventDefault();
        }
    });

    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(EndRequestHandler);
    function EndRequestHandler(sender, args) {
        $("html, body").animate({
            scrollTop: $(".post-back-evaluation.order-form__form").offset().top - 200
        }, 400);

        if ($(".post-back-evaluation.order-form__form").length > 0){
            InitForm();
        }
    }


// if form is present
if (document.querySelector('.phone-field')) {
    Promise.all([
      load.js("/ML/js/helpers/libphonenumber.js")
    ]).then(() => {
      initNumberValidation();
    })
  }

  function initNumberValidation() {
    // najit cislo a ulozit
    var phonefield = $(".phone-field");

    $(".FormButton").on('click', function (e) {
      validateNumber(phonefield.val(), e);
      validateIcoDic("ico" ,e);
      validateIcoDic("dic" ,e);
      validateForm(e);
    });
  };

  function validateNumber(num, e) {
    const util = new libphonenumber.PhoneNumberUtil();
    let isValid;
    try {
      isValid = util.isValidNumber(util.parse(num));
    } catch (err) {
      isValid = false;
    }

    if (!isValid) {
      e.preventDefault();
      if ($(".EditingFormErrorLabel.error").length === 0) {
           $(".phone-field").after("<span class='EditingFormErrorLabel error'>" + errorphone + "</span>");
      } else {
        $(".phone-field .error").show();

      }

    } else {
      $(".phone-field .error").hide();
      clicked = false;
    }
  }
  
  function validateIcoDic (icoORdic, e) {
    let isValid = true;

    var fieldName;
    if (icoORdic == "ico")
        fieldName = ".validate-ico"
    else 
        fieldName = ".validate-dic";

    let fieldValue = $(fieldName).find('input').val();

    if (fieldValue.length < 5 || fieldValue.length > 20)
        isValid = false; 
    else if (!fieldValue.match(/^[0-9a-zA-Z \- \s ]+$/))
        isValid = false;
        
    if (isValid) {
        $(fieldName + " .error").hide();
        clicked = false;
    }
    else {
        //Generating or displaying error
        if ($(fieldName + " .EditingFormErrorLabel.error").length === 0)
            $(fieldName + " input").after("<span class='EditingFormErrorLabel error'>" + (icoORdic == "ico" ? errorICO : errorDIC) + "</span>"); 
        else
            $(fieldName + " .error").show();

        //Scroll up to error
        e.preventDefault();
        let offset = $('.order-form').offset();

        $('html, body').animate({
            scrollTop: offset.top - 50
        }, 10, "linear");
    }
  }

  $('input[readonly]').on('focus', function(ev) {
    $(this).trigger('blur');
  });
  
    if ($(window).width() < 860){
        if($(".submenu__list--menuwrap a").length > 1){
            $(".submenu__list--menubutton").click(function(){
            $(".submenu__list--menuwrap").slideToggle();
            $(".submenu__list--menuwrap").toggleClass("submenu-open");
            $("body").addClass("overlay");
            $("html").addClass("lock");
            }); 
        
            $(".submenu__list--menuwrap a, .submenu__list--menuwrap").click(function(){
            $("body").removeClass("overlay");
            $("html").removeClass("lock");
            $(".submenu__list--menuwrap").slideToggle();
            $(".submenu__list--menuwrap").removeClass("submenu-open");
            });
        } else {
            $("div.submenu__list--menubutton").hide();
            $(".submenu__list--menuwrap").addClass("relative-wrap");
            $(".submenu__list--menuwrap a").addClass("submenu__list--menubutton");
            //alert("test")
        }
    }  

    // if on gallery page
let galleryItems = [];
if (document.querySelector('.gallery')) {
    // prepare array of ordered images for fancyBox
    const leftCol = [...document.querySelectorAll('.left-col .item--single')];
    const rightCol = [...document.querySelectorAll('.right-col .item--single')];
    
    if (leftCol.length > rightCol.length) {
        leftCol.map((el, i) => {
        galleryItems.push(el);
        if (rightCol[i]) {
            galleryItems.push(rightCol[i]);
        }
        });
    } else {
        rightCol.map((el, i) => {
        if (leftCol[i]) {
            galleryItems.push(leftCol[i]);
        }
        galleryItems.push(el);
        });
    }
    // load jquery libs
    load.js('/FaT/js/dist/vendor.js').then(() => attachGalleryHandlers());

    // also open gallery with the button
    const galleryBtn = document.getElementById('openGallery');
    galleryBtn.addEventListener('click', () => openGallery());
}

function attachGalleryHandlers() {
    const galleryLinks = [...document.querySelectorAll('.item--single')];
    if (galleryLinks.length > 0) {
        galleryLinks.map((el) =>
            el.addEventListener('click', (e) => {
                e.preventDefault();
                openGallery(galleryItems.indexOf(el));
            })
        );
    }
}

function openGallery(index = 0) {
    // manually launch fancyBox on selected index
    $.fancybox.open(
        galleryItems,
        {
            hash: false,
            // afterShow: () => console.log('lightbox opened'),
            slideShow: {
                autoStart: false,
                speed: 3000
            }
        },
        index
    );
}
});


function validateForm(e) {
    let isValid = true;
    
    // Validate Name
    if($('.validate-name').find('input').val() == "") {
        isValid = false;
        if ($(".validate-name .EditingFormErrorLabel.error").length === 0) {
            $(".validate-name input").after("<span class='EditingFormErrorLabel error'>" + errorName + "</span>");
        } else {
            $(".validate-name .error").show();
        }
    } else {
        $(".validate-name .error").hide();
    }
    
    // Validate Comapny name
    if($('.validate-firm-name').find('input').val() == "") {
        isValid = false;
        if ($(".validate-firm-name .EditingFormErrorLabel.error").length === 0) {
            $(".validate-firm-name input").after("<span class='EditingFormErrorLabel error'>" + errorCompany + "</span>");
        } else {
            $(".validate-firm-name .error").show();
        }
    } else {
        $(".validate-firm-name .error").hide();
    }

     // Validate Email
     if($('.validate-email').find('input').val() == "") {
        isValid = false;
        if ($(".validate-email .EditingFormErrorLabel.error").length === 0) {
          $(".validate-email input").after("<span class='EditingFormErrorLabel error'>" + errorEmail + "</span>");
        } else {
            $(".validate-email .error").show();
        }
    } else {
        $(".validate-email .error").hide();
    }

    // Validate address
    if($('.validate-address').find('input').val() == "") {
       isValid = false;
       if ($(".validate-address .EditingFormErrorLabel.error").length === 0) {
            $(".validate-address input").after("<span class='EditingFormErrorLabel error'>" + errorAdress + "</span>");
        } else {
            $(".validate-address .error").show();
        }
   } else {
       $(".validate-address .error").hide();
   }

   // Validate date
   if($('.validate-date').find('input').val() == "") {
      isValid = false;
      if ($(".validate-date .EditingFormErrorLabel.error").length === 0) {
        $(".validate-date input").after("<span class='EditingFormErrorLabel error'>" + errorDate + "</span>");
    } else {
        $(".validate-date .error").show();
    }
  } else {
      $(".validate-date .error").hide();
  }
   
   // Validate time
   if($('.validate-time').find('input').val() == "") {
    isValid = false;
        if ($(".validate-time .EditingFormErrorLabel.error").length === 0) {
            $(".validate-time input").after("<span class='EditingFormErrorLabel error'>" + errorTime + "</span>");
        } else {
            $(".validate-time .error").show();
        }
    } else {
        $(".validate-time .error").hide();
    }

    // Validate people
    if($('.validate-people').find('input').val() == "") {
        isValid = false;
        if ($(".validate-people .EditingFormErrorLabel.error").length === 0) {
            $(".validate-people input").after("<span class='EditingFormErrorLabel error'>" + errorPeople + "</span>");
        } else {
            $(".validate-people .error").show();
        }
    } else {
     $(".validate-people .error").hide();
    }
    
    // Validate Service
    let isServiceChecked = false;
    $('.validate-service input').each(function(){
        if($(this).is(":checked")) {
            isServiceChecked = true;
        }
    })

    if(!isServiceChecked) {
        isValid = false;
        if ($(".validate-service .EditingFormErrorLabel.error").length === 0) {
            $(".validate-service").append("<span class='EditingFormErrorLabel error'>" + errorService + "</span>");
        } else {
            $(".validate-service .error").show();
        }
    } else {
     $(".validate-service .error").hide();
    }

    // Validate Aggree
    if(!$('.validate-accept input').is(":checked")) {
        isValid = false;
        if ($(".validate-accept .EditingFormErrorLabel.error").length === 0) {
            $(".validate-accept").append("<span class='EditingFormErrorLabel error'>" + errorAgree + "</span>");
        } else {
            $(".validate-accept .error").show();
        }
    } else {
     $(".validate-accept .error").hide();
    }


    if (!isValid) {
        e.preventDefault();
        let offset = $('.order-form').offset();

        $('html, body').animate({
            scrollTop: offset.top - 50
        }, 10, "linear");
    }
}


$(window).resize(function () {
    adaptBanner();
    adaptImageOnBackground();
    adaptContainerHeight();

});

$(window).on('load', function () {
    adaptImageOnBackground();
    adaptContainerHeight();

    setTimeout(
        function() 
        {
            adaptImageOnBackground();


              // TEAM SLIDER
                owlTeam = $('.team__mobile--img').owlCarousel({
                    loop: true,
                    nav: false,
                    items: 1,
                    autoHeight: true,
                    autoplay: true,
                    autoplaySpeed: 800
                });

                
                owlRef = $('.ref__list').owlCarousel({
                    loop: true,
                    nav: false,
                    items: 1,
                    autoHeight: true,
                    autoplay: true,
                    autoplaySpeed: 800
                });
                
                var owlMeal = $('.meal').owlCarousel({
                    loop: false,
                    nav: true,
                    dots: false,
                    items: 1,
                    autoHeight: true,
                    autoplay: false,
                    autoplaySpeed: 800
                });
                ;
                var owlLunch = $('.lunch').owlCarousel({
                    loop: false,
                    nav: true,
                    dots: false,
                    items: 1,
                    autoHeight: true,
                    autoplay: false,
                    autoplaySpeed: 800
                });
                
                adaptContainerHeight();

                const prev = $('.meal .prev');
                const next = $('.meal .next');
                
                owlLunch.on('changed.owl.carousel', function(event) {
                    setTimeout(
                    function() 
                    {
                        adaptImageOnBackground();
                    }, 250);
                });
                owlMeal.on('changed.owl.carousel', function(event) {
                    setTimeout(
                    function() 
                    {
                        adaptImageOnBackground();
                    }, 250);
                });

        }, 1000);


        setTimeout(
            function() 
            {
                
            adaptImageOnBackground();
        }, 2500);



});

